module.exports = __webpack_public_path__ + "media/images/icon/calendar_sm-72ea5142a18de4288ef15a5331e011c0.svg";